import { Stack, Typography } from '@mui/material';

interface Props {
    fileType?: string;
    label?: string;
}

function getFileIcon(fileType?: string, fallbackLabel?: string) {
    switch (fileType) {
        case 'application/pdf':
            return { label: 'PDF', background: '#d32f2f' };
        case 'application/msword':
            return { label: 'DOC', background: '#1976d2' };
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return { label: 'DOCX', background: '#1976d2' };
        case 'image/jpeg':
        case 'image/jpg':
            return { label: 'JPG', background: '#388e3c' };
        case 'image/png':
            return { label: 'PNG', background: '#388e3c' };
        default:
            return fallbackLabel ? { label: fallbackLabel, background: '#1976d2' } : null;
    }
}

export default function FileItemIcon({ fileType, label }: Props) {
    const icon = getFileIcon(fileType, label);

    if (!icon) return null;

    return (
        <Stack
            alignItems="center"
            justifyContent="center"
            sx={{
                width: 32,
                height: 32,
                borderRadius: '4px',
                color: 'white',
                background: icon.background,
            }}
        >
            <Typography variant="caption" fontWeight="bold" fontSize="10px">
                {icon.label}
            </Typography>
        </Stack>
    );
}
